import { Endpoint } from '../endpoint';
import { AutomationWebhookId, AutomationWebhookResponse } from '@business/entities/automation_webhook';

export function fetchAutomationWebhooks() {
  return Endpoint.get<AutomationWebhookResponse[]>(`@gc/automation-webhook`);
}

export function createAutomationWebhook(webhook: Partial<AutomationWebhookResponse>) {
  return Endpoint.post<AutomationWebhookResponse>(`@gc/automation-webhook`, { data: { ...webhook } });
}

export function updateAutomationWebhook(id: AutomationWebhookId, webhook: Partial<AutomationWebhookResponse>) {
  return Endpoint.patch<AutomationWebhookResponse>(`@gc/automation-webhook/${id}`, { data: { ...webhook } });
}

export function deleteAutomationWebhook(id: AutomationWebhookId) {
  return Endpoint.delete<void>(`@gc/automation-webhook/${id}`);
}
